

export default () => {

    return {

        mounted() {
            let nationalUrl = new URL('https://yfc.net/wp-json/wp/v2/');

            function getJobs() {

                let request = new XMLHttpRequest();
                let url = nationalUrl.toString() + 'job?per_page=100&orderby=title&order=asc';
                request.open('GET', url, true);
                
                request.onload = function() {

                    let jobs = JSON.parse(this.response);

                    jobs.sort((a, b) => a.acf.location.localeCompare(b.acf.location))
                            
                    if (request.status >= 200 && request.status < 400) {
                    
                        const cardContainer = document.querySelector(".jobs-container");
                        const categoryList = document.getElementById('job-type');
                        const chapterList = document.getElementById('chapters');
                        const countDisplay = document.getElementById('job-count');

                        let count = 0;

                        jobs.forEach(job => {

                        let chapterArray = new Array();
                        for (let i = 0; i < chapterList.options.length; i++) {
                         chapterArray[i] = chapterList.options[i].value;
                        }
                        
                        if (job.acf.display == true) {

                            let chapterOption = document.createElement("option");
                            chapterOption.text = job.acf.location;
                            chapterOption.classList.add("text-black");
                            if(job.acf.location == '{{ blockset.salesforce_chapter_name }}') {
                                chapterOption.setAttribute('selected', 'true');
                            }
                            if(!chapterArray.includes(job.acf.location)) {
                            chapterList.add(chapterOption); 
                            }

                            const style = document.getElementById('job-card')
                            const card = style.cloneNode(true)

                            card.setAttribute('id', '');
                            card.classList.remove('hidden');

                            card.setAttribute('x-show','!chapter || chapter === "' + job.acf.location + '"')

                            const location = card.getElementsByTagName('p')[0]
                            location.textContent = job.acf.location;

                            const title = card.getElementsByTagName('p')[1]
                            const decodeHtmlCharCodes = str => str.replace(/(&#(\d+);)/g, (match, capture, charCode) => String.fromCharCode(charCode));
                            title.textContent = decodeHtmlCharCodes(job.title.rendered).replace('&amp;', '&');

                            const model = card.getElementsByTagName('p')[2]
                            model.textContent = job.acf.ministry_model;

                            const site = card.getElementsByTagName('p')[3]
                            site.textContent = job.acf.ministry_site;

                            const city = card.getElementsByTagName('p')[4]
                            if( job.acf.city === '') {
                            city.textContent = job.acf.state;
                            } else {
                            city.textContent = job.acf.city + ', ' + job.acf.state;
                            }
                            
                            const type = card.getElementsByTagName('p')[5]
                            type.textContent = job.acf.type;
                            
                            const link = card.getElementsByTagName('a')[0]
                            link.href = job.link;
            
                            cardContainer.appendChild(card);

                            count = count + 1;

                        }

                        })

                        countDisplay.textContent = count;
                    }
                }

                // Send request to API
                request.send();
            }

            (function() {
                getJobs();
            })();

        }

    }

}